import { Head, usePage } from '@inertiajs/react';

import type { SharedData } from '@/types/shared';

export function AwsWafIntegrationScript() {
  const { awsWafIntegrationScriptUrl } = usePage<SharedData>().props;

  if (!awsWafIntegrationScriptUrl) return null;

  return (
    <Head>
      <script id="aws-waf-integration-script" src={awsWafIntegrationScriptUrl} defer />
    </Head>
  );
}
